import { PHONE, locationSchema } from "../structured-data-core";

export function getDallasStructuredData() {
  const url = "https://restorehair.com/locations/restore-dallas/";
  const description =
    "Restore your confidence with the top hair restoration team serving Dallas and the surrounding Texas metro. Over 20,000 procedures.";
  return [
    locationSchema("Allen", "825 Watters Creek Blvd, Building M Suite 250", "Allen", "TX", PHONE, url, description),
    locationSchema("Dallas – Highland Park", "4514 Cole Avenue, Office #605", "Dallas", "TX", PHONE, url, description),
    locationSchema("Dallas – Plano", "5425 W Spring Creek, Suite 170", "Plano", "TX", PHONE, url, description),
    locationSchema("Fort Worth", "1751 River Run, Suite 200", "Fort Worth", "TX", PHONE, url, description),
    locationSchema("Houston", "2929 Allen Pkwy, Suite 200", "Houston", "TX", PHONE, url, description),
    locationSchema("San Antonio", "700 N St Mary's St, Suite 1400", "San Antonio", "TX", PHONE, url, description),
    locationSchema("South Lake", "950 E State Hwy 114", "Southlake", "TX", PHONE, url, description),
  ];
}
